(ns measure.reporting-ocp.view.tabs.type
  (:require [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.radio :refer [radio-group]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.db.options :as form-options]
            [measure.reporting-ocp.view.tabs.display-variant-type
             :refer [ad-variant-display-type-tab
                     ad-variant-video-type-tab]]
            [measure.reporting-ocp.view.tabs.fields :as tab-fields]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui report-type-field []
  (let [report-type-options (form-options/use-type-options)]
    ($ form-field
       {:label "Report type"}
       (r/as-element
        [radio-group (merge (form/use-bind-control [:type])
                            {:options report-type-options})]))))

(defui content-fields-field []
  (let [content-field-options (form-options/use-field-options :content)]
    ($ form-field
       {:label "Content fields"}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:content-fields])
                         {:options content-field-options
                          :multi? true})]))))

(defui context-fields-field []
  (let [context-field-options (form-options/use-field-options :context)]
    ($ form-field
       {:label "Context fields"
        :err-msg (form/use-error-message [:fields])}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:context-fields])
                         {:options context-field-options
                          :multi? true})]))))

(defui product-fields-field []
  (let [product-field-options (form-options/use-product-field-options)]
    ($ form-field
       {:label "Product fields"
        :err-msg (form/use-error-message [:product-fields])}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:product-fields])
                         {:options product-field-options
                          :multi? true})]))))

(defui options-field []
  ($ form-field
     {:label "Options"}
     ($ checkbox
        (merge (form/use-bind-control [:aggregate-daily])
               {:id :aggregate-daily
                :label "Aggregate by day"}))))

(defui type-tab []
  (let [report-type-options (form-options/use-type-options)
        report-type (use-subscribe [:form.report/value [:type]])
        report-channel (use-subscribe [:form.report/value [:adset-channel]])
        selected-adset-workflows (form-options/use-selected-adset-workflows)
        report-type-not-allowed? (not-any? #(= (:value %) report-type) (remove :disabled? report-type-options))]
    (uix/use-effect (fn []
                      (when report-type-not-allowed?
                        (rf/dispatch [:form.report/on-change [:type] (->> report-type-options
                                                                          (remove :disabled?)
                                                                          first
                                                                          :value)])))
                    [report-type-not-allowed? report-type-options])
    (cond
      (and (contains? selected-adset-workflows "ad-variants")
           (= report-channel "display"))
      ($ ad-variant-display-type-tab)

      (and (contains? selected-adset-workflows "ad-variants")
           (contains? #{"video" "ctv"} report-channel))
      ($ ad-variant-video-type-tab)

      :else
      ($ :<>
         ($ report-type-field)

         (when (contains? form-options/metric-report-types report-type)
           ($ tab-fields/metrics-field))

         (when (contains? form-options/fields-report-types report-type)
           ($ :<>
              ($ content-fields-field)
              ($ context-fields-field)))

         (when (contains? form-options/product-fields-report-types report-type)
           ($ product-fields-field))

         ($ options-field)))))
